const copyPasteRequestStr = {
  toastr: 'Recorte hecho',
  toastr1: 'Recorte hecho con éxito'
};

export default copyPasteRequestStr;
